(function () {
	"use strict";

	angular.module("swurveys.maker")
		.controller("editorController", Handler);

	function Handler(
		$scope, $location, $timeout, $routeParams, $interval, $window,
		swurveysStageConfig, utilsService, loggedInUser, imageService,
		analyticsService,	paymentTierModal, publishModal, shareModal, cardFormService,
		cardListService, swurveyService, swurveyAdminService, authService, embedSwurveyModal, liveReloadService) {


		utilsService.bindEventHandler("beforeunload", function (e) {
			var swurveyString = angular.toJson($scope.selectedSwurvey);

			if (cachedSwurveyString !== swurveyString) {
				var confirmationMessage = 'Changes you made may not be saved.';
				(e || window.event).returnValue = confirmationMessage; //Gecko + IE
				return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
			}
		});

		/**
		 * Called when user attempts to exit editor page
		 */
		$scope.$on("$locationChangeStart", function (event) {
			if(!$scope.swurveyInitComplete) return;
			if($scope.autoSaveMode) {
			  $scope.saveModel();
			} else if($scope.isSwurveyDirty()) {
				//Swurvey is dirty, make sure they want to leave.
				if(!$window.confirm("Swurvey has not been saved. You must manually save this Swurvey. Are you sure you want to exit?")) {
				  event.preventDefault();
					return;
				}
			}
			utilsService.cleanUpStyle(null, true);
			$interval.cancel(autosaveInterval);
			tearDownLiveReload();
		});

		var disabledFeatures = {};

		var swurveyId = $routeParams.sid;

		var draggingPosition;

		var credential = loggedInUser;

		var ownerId;
		var sessionId = utilsService.generateUUID();
		var tearDownLiveReload = function(){};

		/**
		 * In the dnd-drop callback, we now have to handle the data array that we
		 * sent above. We handle the insertion into the list ourselves. By returning
		 * true, the dnd-list directive won't do the insertion itself.
		 */
		$scope.onDragOver = function (index) {
			draggingPosition = index;
			if(index === 0 || index >= -~$scope.selectedSwurvey.model.cards.length) {
				return false;
			}
			return true;
		};

		/**
		* Last but not least, we have to remove the previously dragged items in the
		* dnd-moved callback.
		*/
		$scope.onMoved = function (index) {
			$scope.switchNavTab(draggingPosition + (draggingPosition > index ? -1 : 0));
			$scope.selectedSwurvey.model.cards.splice(index, 1);
			draggingPosition = undefined;
		};

		//Fields --------------------------------------------------------------

		$scope.user = loggedInUser;

		$scope.wysiwygOptions = {
			height: 100,
			menubar: false,
			statusbar: false,
			format: 'raw',
			formats: {
    		bold: { inline: 'b' }
			},
			toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | fontsizeselect',
			content_style: "body p {font-size: 1.5em; }",
			fontsize_formats: '.6em .8em 1em 1.2em',
			extended_valid_elements: "b,b/strong",
			defaultContent: '<p style="text-align: center"></p>'
		};

		$scope.enablePayments = swurveysStageConfig.getConfigPropertyValue("enable_payments");

		$scope.swurveyInitComplete = false;

		$scope.navTab = 0;

		$scope.cardTab = 0;

		$scope.inEditor = true;

		$scope.previewToggle = false;

		$scope.defaultShareImage = "https://app.swurveys.com/assets/fbpreview.jpeg";

		$scope.shareOptions = {
			facebook: false,
			google: false,
			linkedin: false,
			twitter: false,
			mail: false,
			sms: false
		};

		$scope.jsonEdit = {
			data: {
				loading: "Swurvey Data..."
			},
			options: {
				mode: 'tree',
				expanded : true,
				timeout: 500
			}
		};

		$scope.cardTypes = ["content" , "binary", "three", "four", "slider"];
		$scope.getAnswerTemplates = cardFormService.getAnswerTemplates;

		$scope.changeAnswerTemplate = function(card) {
			cardFormService.changeAnswerTemplate(card);
		}

		var questionTypes = $scope.cardTypes.slice(1);

		var uid = credential.swurveys.identityId();
		var cachedSwurveyString = '';

		//Methods -------------------------------------------------------------

		var autosaveInterval;
		var interval = 3000;

		var startAutosaveInterval = function () {
			autosaveInterval = $interval(function () {
				$scope.saveModel();
			}, interval);
		};

		/**
		 * Changes navigation tab
		 * @param index Index of desired tab
		 */
		$scope.switchNavTab = function (index) {
			$scope.navTab = index;
			$scope.previewTab = index;
			if(index >= 0) $scope.cardTab = index;
		};

		// Card funtions TODO: Add an argument to add card at a certain index
		$scope.addCard = cardListService.addCard.bind($scope, $scope.switchNavTab);
		$scope.deleteCard = cardListService.deleteCard.bind($scope, $scope.switchNavTab);
		$scope.cloneCard = cardListService.cloneCard.bind($scope, $scope.switchNavTab);
		$scope.changeCardType = cardListService.changeCardType.bind($scope, updateCardImg);

        //If the swurvey has been modified, return the new cache string
		//else, return false
		$scope.isSwurveyDirty = function() {
			var swurveyString = angular.toJson($scope.selectedSwurvey);
			if(cachedSwurveyString === swurveyString) return false;
			return swurveyString;
    };

		/**
		 * Saves current state of swurvey model
		 */
		$scope.saveModel = function (callback) {

			var swurveyString = $scope.isSwurveyDirty();

			if (!swurveyString) {
			  if(callback) callback();
 				return;
 			}

 			cachedSwurveyString = swurveyString;
			$scope.saveState = 'saving';

			swurveyAdminService.putModel($scope.selectedSwurvey.id, $scope.selectedSwurvey.model, function (err) {
				if(err) {
					$interval.cancel(autosaveInterval);
					authService.relogin();
					return console.error(err);
				}
				$scope.saveState = 'saved';
			  if(callback) callback();
			});

			//We're going to go ahead and publish this to IoT async with the putModel above.
			var subTopic = "swurveys/" + $scope.selectedSwurvey.id + "/model";
			swurveyAdminService.publishUserUpdate(ownerId, sessionId, $scope.selectedSwurvey.id, subTopic, 'putModel', $scope.selectedSwurvey.model);

		};

		function removeBasicOptions() {
			$scope.selectedSwurvey.model.options.publicData = true;

		  if($scope.selectedSwurvey.model.options.shareImg) {
		  	disabledFeatures.shareImg = $scope.selectedSwurvey.model.options.shareImg;
		  }

			$scope.selectedSwurvey.model.options.share = {
				enabled: true,
				text: "",
				methods: [
					"facebook",
					"twitter",
					"google",
					"linkedin",
					"sms"
				]
			};

			$scope.shareOptions["facebook"] = true;
			$scope.shareOptions["twitter"] 	= true;
			$scope.shareOptions["google"] 	= true;
			$scope.shareOptions["linkedin"] = true;
			$scope.shareOptions["sms"] 			= true;
			$scope.shareOptions["email"] 		= false;

			$scope.selectedSwurvey.model.options.customEmail = {
				enabled: false,
				text: "",
				methods: []
			};
		}

		function removePremiumOptions() {
			$scope.selectedSwurvey.model.options.customEmail = {
				enabled: false,
				text: "",
				methods: []
			};

			$scope.selectedSwurvey.model.options.action = {
				enabled: false,
				text: "",
				methods: []
			};

			//The following foreach should not affect the cover, so let's pop it off the front and restore it later
			var cover = $scope.selectedSwurvey.model.cards.shift();
			$scope.selectedSwurvey.model.cards.forEach(function(card) {
				if(card.type == "content" && card.img ) {
					card.oldImg = card.img;
					delete card.img;
				}
			});

			$scope.selectedSwurvey.model.cards.unshift(cover);
		}

		function restorePremiumOptions() {
			$scope.selectedSwurvey.model.cards.forEach(function(card) {
				if(card.type == "content" && card.oldImg) {
					card.img = card.oldImg;
					delete card.oldImg;
				}
			});
			if(disabledFeatures.shareImg) {
				$scope.selectedSwurvey.model.options.shareImg = disabledFeatures.shareImg;
				delete disabledFeatures.shareImg;
			}
		}

		$scope.showSwurveyTierModal = function () {
			paymentTierModal.show($scope.selectedSwurvey).then(function (modal) {
				modal.element.modal();
				modal.close.then(function (tier) {
					if (tier) {
						$scope.selectedSwurvey.model.paymentTier = tier;
						if (tier === "Free") {
							removePremiumOptions();
							removeBasicOptions();
						} else if (tier === "Feedback") {
							removePremiumOptions();
						} else if (tier === "FeedbackPlus") {
							restorePremiumOptions();
						}
					}
				});
			});
		};

		/**
		 * Publishes swurvey
		 * @param id Target swurvey id
		 */
		$scope.publishSwurvey = function () {

			var TierToPriceTable = {
				'Free': 0,
				'Feedback': 1,
				'FeedbackPlus': 3,
				'Engagement': 5
			};

			var SCMultiplyer = TierToPriceTable[$scope.selectedSwurvey.model.paymentTier];

			var user = $scope.user.user;
			user.identityId = loggedInUser.swurveys.identityId();

			analyticsService.trackEvent('PublishSwurveyMaybe', swurveyId);
			publishModal.show($scope.selectedSwurvey, SCMultiplyer, user).then(function (modal) {
				modal.element.modal();
				modal.close.then(function (result) {
				  if(result == 'publish' || (result && result.bitly)) {
						analyticsService.trackEvent('PublishSwurvey', swurveyId);
						var freeStyle = $("style#free-style")[0].sheet;
						freeStyle.disabled = true;
				    embedSwurveyModal.show("4316ade47d394c27bf77d49ab1bab144", loggedInUser.user.email + "|" + swurveyId);
						shareModal.show(result).then(function (modal) {
							modal.close.then(function () {
								utilsService.gotoDashboard(uid);
							});
						});
					}
				});
			});
		};

		var startWebsocket = function () {
			var stage = swurveysStageConfig.getConfigPropertyValue("api_endpoint").split("/").pop();
			var topic = stage + "/users/" + ownerId + "/swurveys/" + swurveyId + "/model";

			tearDownLiveReload = liveReloadService.init(AWS.config.credentials, ownerId + new Date().getTime(), topic, function (msg) {
				if (sessionId == msg.sessionId) {
					//We published this update, so ignore it.
					return;
				}
				if (cachedSwurveyString == $scope.isSwurveyDirty())
				{
					analyticsService.trackEvent('LiveCollabLostChange', swurveyId);
					console.log("Local changes overwritten by remote change");
				}

				var model= msg.payload;

				//Update the model
				$scope.selectedSwurvey.model = model;
				//Update our cached Model, so we don't immediately save again
				cachedSwurveyString = $scope.isSwurveyDirty();

				//Extract our styles
				$scope.extractModel(model);

			});
		}

		/**
		 * Change swurvey model
		 * @param selectedSwurvey	Swurvey object to load model from
		 */
		var changeSwurvey = function (selectedSwurvey) {
			swurveyService.getModel(selectedSwurvey.id, function (err, res) {
				if(err) {
					console.log("Swurvey not found. An error occurred...");
					utilsService.gotoDashboard(uid);
					return console.log(err);
				}

				var model = res.data;

				$scope.shareURL = res.headers("x-swv-short-url");
				var state = res.headers("x-swv-state");
				ownerId = res.headers("x-swv-owner").substr(5);

				$scope.selectedSwurvey = {
					id: selectedSwurvey.id,
					model: model,
					state : state,
					ownerId : ownerId
				};
				startWebsocket();

				if(!model.options.opengraph && model.options && model.options.shareImg) {
					model.options.opengraph = { "og:image" : model.options.shareImg.default };
				}
				if(!model.fileLibrary) {
					model.fileLibrary = [];
				}

				//So we don't trigger a save right when the page loads.
				$scope.extractModel(model, function() {
					$scope.autoSaveMode = false;
					if($scope.selectedSwurvey.state == "New") {
						startAutosaveInterval();
						$scope.autoSaveMode = true;
					}

				  cachedSwurveyString = $scope.isSwurveyDirty();
			    $scope.swurveyInitComplete = true; // tells the view the initialization is complete and allows it to load the data.
				});

				switch(state) {
					case 'New':
						break;
					case 'Published':
						if(!$scope.advancedMode) {
						  alert("Swurvey is Published, I'm returning you to the dashboard.");
						  utilsService.gotoDashboard(uid);
						}
						break;
					default:
						break;
				}
			});
		};

		var cleanInvalidCSS = function(styles) {
			//Given our styles array, remove CSS styles that we don't think are valid
			//Returns the new array

			var CSSValidate = /^([^{]*{[^{}]*}|[^{}]*)$/

			var cleaned = [];
			styles.forEach(function(styleString) {
				//remove whitespace
				var stripped = styleString.trim();
				if(CSSValidate.test(stripped) || stripped.startsWith("@")) {
					cleaned.push(stripped);
				} else {
					console.log("Ignoring style:", stripped);
				}
			});
			return cleaned;
		};

		var CSSatRulesArray = [];
		var setCSSJsonModel = function(cssArray) {
			//Here we convert CSS to json to insert into our angular model
			//so users can use the theme tab to update the styles
			//Unfortunately, duplicate keys lead to problems and only one
			//of the rules will actually get into the model, and thus we
			//end up overwriting the other rule(s)
			//with @at-rules(like @font-face), they all have the same key
			//so pull the at-rules out, and don't put them into our model
			//When we extract JSON->CSS, we add the at-rules back in
			//@at-rules are only used by premium designers, so we'll have to figure
			//out how to address this when we put this in the regular designer
			CSSatRulesArray = [];
			var nonAtRules = [];
			cssArray.forEach(function(styleString){
				if(styleString.startsWith('@')) {
					CSSatRulesArray.push(styleString);
				} else {
					nonAtRules.push(styleString);
				}
			});

			var cssString = nonAtRules.join(" ");
			$scope.jsonModel = CSSJSON.toJSON(cssString);
		}

		/**
		 * Extract styling from swurvey model
		 * @param model Swurvey model
		 */
		$scope.extractModel = function(model, callback) {

      var cssArray = cleanInvalidCSS(model.styles);
			refreshCSS(cssArray);
			setCSSJsonModel(cssArray);

			var jmc = $scope.jsonModel.children;

			var shareMethods = model.options.share.methods;

			shareMethods.forEach(function(method) {
				$scope.shareOptions[method] = true;
			});

			angular.extend($scope, {

				logoImage: jmc[".logo-image"],
				// Card & Body
				cardBackground: jmc[".card-top-bg"],
				cardBorder: jmc[".card-border"],
				viewer: jmc[".viewer"],

				// Text & Chevrons
				textMain: jmc[".card-text"],
				textAccent: jmc[".card-text b"],
				textAnswer: jmc[".hint-text"],
				cardCounter: jmc[".counter-wrapper b"],
				chevron: jmc[".viewer .fa"],

				// Slider
				slider: jmc[".slider-control"],
				circle: jmc[".circle"],
				sliderHandle: jmc[".ui-slider-horizontal .ui-slider-handle"],

				// WOT
				WOTPercentage: jmc["#WOTPercentage"],
				WOTMainText: jmc[".WOTMainText"],
				WOTText: jmc[".WOTText"],
				WOTIcons: jmc[".socialcircle"],

				// Action
				WOTPublicDataLink: jmc[".dataLink"],
				WOTCustomLink: jmc[".custom-link"],

				// Images
				loadingImage: jmc["#loading"]
			});

			if(callback) callback();

		};

        //Given an array of card 'types', return the index of the first card of any of those types
		$scope.findFirstIndexOfTypes = function(types)
		{
			console.log("looking for types:", types);
			return $scope.selectedSwurvey.model.cards.findIndex(function(card){
				return types.indexOf(card.type) > -1;
			});
		}

		//Given a card type, set the preview pane to preview the first card of that type.
		//'action', as a special string, will change it to the action tab
		$scope.previewFirstCardOfType = function (type) {
			var firstIndex = $scope.findFirstIndexOfTypes([type]);
			if (firstIndex > 0) {
				return $scope.cardTab = $scope.previewTab = firstIndex;
			}
			if (type == "action") {
				return $scope.cardTab = $scope.previewTab = 'action';
			}
		};

		$scope.hasCardOfType = function (type) {
			return $scope.selectedSwurvey.model.cards.filter(function (card) {
				return card.type == type;
			}).length > 0;
		};

		//Given an array of CSS Strings, Remove the existing custom styles, clean up invalid styles, and insert the new styles
		var refreshCSS = function (cssArray) {

			var freeStyle = $("style#free-style")[0].sheet;

			utilsService.cleanUpStyle(freeStyle, false);

			cssArray.forEach(function (style) {
				var index = freeStyle.cssRules.length;
				try {
				  var ret = freeStyle.insertRule(style, index);
				} catch(e) {
					console.log("Could not insert rule:", style);
				}
			});
			$scope.selectedSwurvey.model.styles = cssArray;
		};

		var refreshCSSFromNGModel = function(model) {
			  var cssArray = utilsService.CSSArrayFromJSONChildren(model);
			  refreshCSS(CSSatRulesArray.concat(cssArray));

		}



		//We can't seem to use 'delete' from our view, so wrap it in a scope function
		$scope.deleteJSONCSSProp = function(obj, prop)
		{
			delete obj[prop];
			//For some reason our watch below isn't doing the refresh, so let's manually readd styles
			refreshCSSFromNGModel($scope.jsonModel.children);
		}

		/**
		 * Called with swurvey JSON model changes
		 */
		$scope.$watch("jsonModel.children", function (newChildren) {
			console.log("children changed");
			if($scope.swurveyInitComplete) {
				refreshCSSFromNGModel(newChildren);
			}
		}, true);

		/**
		 * Adds or removed a share action
		 * @param type The type of share funtion to toggle (ex: facebook)
		 */
		$scope.toggleShare = function (type, value) {
			var methods = $scope.selectedSwurvey.model.options.share.methods;

			if(value) {
				if(methods.length === 5) {
					alert("We can only fit 5 Social Sharing icons here. Sorry 😞");
					return $scope.shareOptions[type] = false;
				}
				methods.push(type);
			} else {
				var index = methods.indexOf(type);
				methods.splice(index, 1);
			}
		};

		$scope.addCustomLink = function () {
			if(!$scope.selectedSwurvey.model.options.action.methods) {
				$scope.selectedSwurvey.model.options.action.methods = [];
			}

			var methods = $scope.selectedSwurvey.model.options.action.methods;

			methods.push({
				text: "",
				link: ""
			});
		};

		$scope.addCustomEmail = function () {
			if(!$scope.selectedSwurvey.model.options.customEmail.methods) {
				$scope.selectedSwurvey.model.options.customEmail.methods = [];
			}
			var methods = $scope.selectedSwurvey.model.options.customEmail.methods;

			methods.push({
				text: "",
				recipent: "",
				subject: "",
				body: ""
			});
		};

		/**
		 * Updates CSS class background with image
		 * @param imgSrc 	URL of image
		 * @param ref		 	Reference to CSS class
		 * @param cardRef	Reference to card being modified
		 */
		function updateCardImg(imgSrc, ref, cardRef, attr) {
			attr = attr || 'background-image';
			if(imgSrc) {
				analyticsService.trackEvent('UploadImage', swurveyId);
			}
			$scope.$evalAsync(function () {
				if(!cardRef) {
					if(!ref.attributes)
					{
						ref.attributes = {};
					}
					ref.attributes[attr] = "url(" + (imgSrc || " ") + ")";
				} else {
					cardRef.img = imgSrc;
				}
			});
		}

		$scope.uploadCardImg = function (ref, cardRef) {

			var CARD_ASPECT_RATIO = 1/1.412;

			imageService.getCroppedImageObj(CARD_ASPECT_RATIO).then(function (croppedImageObj) {
				updateCardImg("images/loading.gif", ref, cardRef);
				imageService.uploadImg(credential, croppedImageObj.croppedImageBlob, croppedImageObj.fileType).then(function (imgSrc) {
					$scope.selectedSwurvey.model.fileLibrary.push({url : imgSrc});
					updateCardImg(imgSrc, ref, cardRef);
				}, function (err) {
					console.log(err);
					updateCardImg(undefined, ref, cardRef);
				});
			}, function (errorObj) {
				if(errorObj.alert)
					alert(errorObj.msg);
			});
		};


		//Given a jmc css object, set the property value to url('{url}')
		$scope.uploadImageForCSS = function(cssObj, attribute, ratio) {
			console.log("replacing", cssObj, attribute);

			imageService.getCroppedImageObj(ratio).then(function (croppedImageObj) {
				imageService.uploadImg(credential, croppedImageObj.croppedImageBlob, croppedImageObj.fileType).then(function (imgSrc) {
					$scope.selectedSwurvey.model.fileLibrary.push({url : imgSrc});
					updateCardImg(imgSrc, cssObj, null, attribute);
				}, function(err){
					console.log(err);
				});
			}, function(err) {
				console.log(err);
			});
		};


		$scope.uploadShareCoverImg = function (tag) {

			var FACEBOOK_COVER_ASPECT_RATIO = 1.91/1;

			var oldImgSrc = $scope.selectedSwurvey.model.options.opengraph[tag];

			imageService.getCroppedImageObj(FACEBOOK_COVER_ASPECT_RATIO).then(function (croppedImageObj ) {
				$scope.selectedSwurvey.model.options.opengraph[tag] = null;
				imageService.uploadImg(credential, croppedImageObj.croppedImageBlob, croppedImageObj.fileType).then(function (imgSrc) {
					$scope.selectedSwurvey.model.fileLibrary.push({url : imgSrc});
					$scope.selectedSwurvey.model.options.opengraph[tag] = imgSrc;
					$scope.selectedSwurvey.model.options.opengraph[tag + ":width"] = croppedImageObj.width;
					$scope.selectedSwurvey.model.options.opengraph[tag + ":height"] = croppedImageObj.height;
				}, function (err) {
					$scope.selectedSwurvey.model.options.opengraph[tag] = oldImgSrc;
				});
			}, function (errorObj) {
				if(errorObj.alert)
					alert(errorObj.msg);
			});
		};

		$scope.removeImg = function (ref, cardRef) {
			imageService.removeImg().then(function () {
				updateCardImg(undefined, ref, cardRef);
			});
		};

		$scope.uploadFile = function(destination, destinationPropertyName, isForCSS) {
			console.log(destination);
			delete destination[destinationPropertyName];
			imageService.getBase64ImageObj().then(function(inputData){
				var blob = imageService.blobFromDataURL(inputData.base64Img);
				imageService.uploadImg(credential, blob, inputData.fileType).then(function(newFileURL){
					$scope.selectedSwurvey.model.fileLibrary.push({url : newFileURL});
					if(isForCSS)
					{
						newFileURL = "url(" + newFileURL + ")";
					}
					destination[destinationPropertyName] = newFileURL;
				});
			});

		};

		$scope.extractBG = imageService.extractBG;

		/**
		 * Authenticate user
		 */
		if(credential.isLoggedIn()) {
			if($routeParams.sid) {
				changeSwurvey({ id: $routeParams.sid });

				if(credential.user.isAdmin == true || credential.user.userType.indexOf("Agency") >= 0) {
					//admins and agencys get faster autosaves
					interval = 1000;
				}

				$scope.advancedMode = credential.user.isAdmin == true || credential.user.userType == "advanced";
				$scope.betaMode = credential.user.userType.indexOf("Beta") >= 0 || credential.user.isAdmin;
				$scope.agencyMode = credential.user.userType.indexOf("Agency") >= 0 || credential.user.isAdmin;
				analyticsService.trackEvent('EditSwurvey', swurveyId);

			} else {
				utilsService.gotoDashboard(uid);
			}
		} else {
			authService.relogin();
		}

		$scope.getControlHint = function(shouldShowHint, hint) {
			if(shouldShowHint) {
				return hint;
			} else {
				return "You must upgrade to a higher paid tier to use this feature";
			}
		};

		$scope.$watch('selectedSwurvey.model.paymentTier', function () {
			//We do this to simplify the logic in our templates
			if ($scope.selectedSwurvey) {
				$scope.isBasic = $scope.advancedMode || $scope.selectedSwurvey.model.paymentTier != "Free";
				$scope.isPremium = $scope.advancedMode || $scope.selectedSwurvey.model.paymentTier == "Engagement" || $scope.selectedSwurvey.model.paymentTier == "FeedbackPlus";
			}
		});

		$scope.openPaymentTierModalIfTrue = function(shouldOpen) {
			if(shouldOpen) $scope.showSwurveyTierModal();
		};

		$scope.defaultText = utilsService.defaultText;

		$scope.getExtrasName = function() {
			var name = ['E',"Extras"];
			var model = $scope.selectedSwurvey.model;
			if(model && model.options && model.options.leadgen && model.options.leadgen.enabled)
			{
				name = ['L', "Leads"];
			}
			if(model && model.options && model.options.referralCard && model.options.referralCard.enabled)
			{
				name = ["🎁", "Refer"];
			}
			if(model && model.options && model.options.extendedFeedback && model.options.extendedFeedback.enabled)
			{
				name = ["💬", "Comments"];
			}
			return name;
		}

	};

}());
